import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskLectureGroupVm } from '../my-osk-lecture-group-vm.model';
import { IMyOskLectureGroupArchiveUm } from '../my-osk-lecture-group-archive-um.model';
@Injectable({ providedIn: 'root' })
export class MyOskLectureGroupArchiveService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureGroupArchive`;
  }
  put(myOskLectureGroupArchiveUm: IMyOskLectureGroupArchiveUm): Observable<IMyOskLectureGroupVm> {
    const headers = this.createHeaders();
    return this.http.put<IMyOskLectureGroupVm>(this.baseUrl, myOskLectureGroupArchiveUm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
